export default "__VITE_ASSET__Dch3c8Q5__"